import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetRoles = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/roles`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getRolesMutation: mutation.mutate,
    };
}